import './index.scss';
import { useCallback, useContext } from 'react';
import { Modal } from 'src/component/Modal';
import { AppText, FlexRow, Button } from 'src/style';
import { AiOutlineClose, AiOutlineCheck } from 'react-icons/ai';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const DeleteResultModal = () => {
    const { API } = useContext(ApiContext);
    const { info } = useContext(AppInfoContext);
    const { visibility, setModal } = useContext(VisibilityContext);

    const handleCancel = () => {
        setModal({ key: "deleteResultModal", value: false });
    };

    const handleSubmit = useCallback(async () => {
        if (info) {
            const payload = {
                session: info.result?.session,
                studentClass: info.result?.studentProfile?.memberClass,
                studentName: info.result?.studentProfile?.username,
                term: info.result?.term,
            }
            const response = API.deleteResult(payload)
            if (response) {
                handleCancel()
            }
        }
    }, [info])

    return (
        <Modal
            className='delete-result-modal'
            open={visibility.deleteResultModal}
            cancel={handleCancel}
        >
            <AppText
                textSize='1.6'
                fontWeight='600'
                color='#324452'
                align='center'
            >
                Are you sure you want to delete this result?
            </AppText>

            <FlexRow isMaxWidth>
                <FlexRow topMargin='2' justifyContent='space-between' className='btn-container'>
                    <Button
                        hoverColor='#A77B37'
                        onClick={handleCancel}
                        className='delete-btn cancel'
                    >
                        <AiOutlineClose size={17} />
                        Cancel
                    </Button>
                    <Button
                        hoverBgColor='#fff'
                        hoverColor='#A77B37'
                        borderColor='#A77B37'
                        onClick={handleSubmit}
                        className='delete-btn confirm'
                    >
                        <AiOutlineCheck size={17} />
                        Confirm
                    </Button>
                </FlexRow>
            </FlexRow>
        </Modal>
    )
};
